import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import RootReducer from './root.reducers';

// NOTE: Comment the below line in case you need to debug the redux store.
// __UNCOMMENT_DEBUG_CODE__
const KaveriAppStore = createStore(RootReducer, applyMiddleware(thunk));
export default KaveriAppStore;
